/**
 * useServiceHealth Hook (Web)
 * Thin wrapper around shared useServiceHealth
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import { useServiceHealth as useServiceHealthShared } from '@parlay-picker/shared/hooks/useServiceHealth';
import type { ExternalApiHealth } from '@parlay-picker/shared/serviceHealth';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export function useServiceHealth(enabled = true): ExternalApiHealth | null {
  const { authFetch } = useAuth();
  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );
  return useServiceHealthShared({ httpClient, enabled });
}
